export default "__VITE_ASSET__BpqOs6MF__"